import React from 'react';
import { Megaphone } from 'lucide-react';

interface AnnouncementBarProps { text: string; }

const AnnouncementBar: React.FC<AnnouncementBarProps> = ({ text }) => {
  if (!text) return null;
  return (
    // Kept py-3.5 to ensure enough vertical space for larger font
    <div className="bg-yellow-50 dark:bg-yellow-900/20 border-y border-yellow-100 dark:border-yellow-900/30 py-3.5 relative overflow-hidden mb-2 mx-4 rounded-lg">
      {/* Icon Container */}
      <div className="flex items-center absolute left-0 top-0 bottom-0 z-10 bg-yellow-50 dark:bg-[#2c241b] px-3 shadow-sm border-r border-yellow-100 dark:border-yellow-900/30">
        <Megaphone size={18} className="text-orange-500 dark:text-orange-400 animate-pulse" />
      </div>
      
      {/* Text Marquee Container */}
      <div className="flex overflow-hidden items-center h-full">
        {/* Changed text-sm to text-base to make text slightly larger */}
        <div className="animate-marquee inline-block text-base font-myanmar text-orange-800 dark:text-orange-300 font-medium pl-12 leading-loose pt-0.5">
          {text}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;